import React, { Component } from 'react'
import styled from 'styled-components'

const Box = styled.div`
    width: calc(100% - 0.75rem);
    margin: 1.5rem 0 0 0;
    display: flex;
    flex-direction: column;

    @media (max-width: 600px) {
        width: 100%;
    }
`

export default class FullCell extends Component {
  render() {
    return <Box {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Grid/FullCell.js